export const styles = () => ({
  line1: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  line2: {
    textAlign: 'center',
  },
}) as const
